// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_9Thuo fl","box":"index_box_rGovm"};